import script from "./Report_new.view.vue?vue&type=script&lang=ts&setup=true"
export * from "./Report_new.view.vue?vue&type=script&lang=ts&setup=true"

import "./Report_new.view.vue?vue&type=style&index=0&id=a747f05a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a747f05a"]])

export default __exports__